import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';
import {palette} from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const BdsPresets = definePreset(Aura, {
  semantic: {
    primary: palette('{blue}')
  }
});

export default BdsPresets;
